import { StorageForecastingAddOns } from '@/enums/storageForecasting/StorageForecastingAddOnsEnum.ts';
import { IEnactPageAccessItem, IEnactPagesAccess } from '@/interfaces/auth/IEnactPagesAccess.ts';
import { IGeneralPagesAccessKeys } from '@/interfaces/auth/IGeneralUserAccessResponse.ts';
import { IShortTermPowerPagesAccessKeys } from '@/interfaces/auth/IPowerMarketsGbAccess.ts';
import { IStorageForecastingAccess, IStorageForecastingPagesAccessKeys } from '@/interfaces/auth/IStorageForecastingAccess.ts';
import { IStorageTrackingPagesAccessKeys } from '@/interfaces/auth/IStorageTrackingAccess.ts';

export function mergePageAccess (target: IEnactPagesAccess, update: Partial<IEnactPagesAccess>): void {
    Object.entries(update).forEach(([key, value]) => {
        if (!value) return;

        const typedKey = key as keyof IEnactPagesAccess;
        target[typedKey] = value;
    });
}

export function mapStorageForecastingAccess (pages: IStorageForecastingPagesAccessKeys, config: IStorageForecastingAccess | null): Partial<IEnactPagesAccess> {
    const bessAccess: boolean = !!config && config.countryAccess.some(country => country.addOns.some(addOn => addOn.addOn === StorageForecastingAddOns.BessForecasting)
        && country.addOns.some(addOn => addOn.addOn === StorageForecastingAddOns.QuarterlyPowerCurves && !addOn.isTrial));
    const forecastReportAccess: IEnactPageAccessItem = { hasAccess: bessAccess, noAccessMessage: '"This page requires <b>Long Term Power - BESS Forecasting & Quarterly Power Curves</b> access."' };

    return {
        longTermPowerOverview: pages.longTermPowerOverview,
        assets: pages.assets,
        marketAssumptions: pages.marketAssumptions,
        capacityMarket: pages.capacityMarket,
        tnuos: pages.tnuos,
        tlms: pages.tlms,
        outputs: pages.outputs,
        comparison: pages.comparison,
        forecastReport: forecastReportAccess,
    };
}

export function mapStorageTrackingAccess (pages: IStorageTrackingPagesAccessKeys): Partial<IEnactPagesAccess> {
    return {
        assetTrackingOverview: pages.assetTrackingOverview,
        marketTrends: pages.marketTrends,
        rankings: pages.rankings,
        companySearch: pages.companySearch,
        projectSearch: pages.projectSearch,
        registers: pages.registers,
        customCharting: pages.customCharting,
        projectUpdates: pages.projectUpdates,
    };
}

export function mapGeneralAccess (pages: IGeneralPagesAccessKeys): Partial<IEnactPagesAccess> {
    return {
        admin: pages.admin,
        chat: pages.chat,
    };
}

export function mapShortTermPowerAccess (pages: IShortTermPowerPagesAccessKeys) :Partial<IEnactPagesAccess> {
    return {
        current: pages.current,
        'monthly-summary': pages['monthly-summary'],
        dashboard: pages.dashboard,
        'storage-da-analysis': pages['storage-da-analysis'],
        'boa-dashboard': pages['boa-dashboard'],
        'plant-table': pages['plant-table'],
        registers: pages.registers,
        'epex-grid': pages['epex-grid'],
        europeOverview: pages.europeOverview,
        europeanAnalysis: pages.europeanAnalysis,
        valueStreamAnalysis: pages.valueStreamAnalysis,
        wholesaleData: pages.wholesaleData,
        universalExporter: pages.universalExporter,
        'ancillary-contracts': pages['ancillary-contracts'],
        'bingo-card': pages['bingo-card'],
        plantActivityBoard: pages.plantActivityBoard,
        'remit-summary': pages['remit-summary'],
        'weather-forecasting': pages['weather-forecasting'],
        'wind-forecasting': pages['wind-forecasting'],
        'map-page': pages['map-page'],
        'europe-map-page': pages['europe-map-page'],
        'bingo-map': pages['bingo-map'],
        'zonal-build-up': pages['zonal-build-up'],
        'historic-analysis': pages['historic-analysis'],
        'forecast-history': pages['forecast-history'],
        news: pages.news,
        notifications: pages.notifications,
        glossary: pages.glossary,
        leaderboard: pages.leaderboard,
        index: pages.index,
        'bess-carbon-emissions-calculator': pages['bess-carbon-emissions-calculator'],
        apiInstructions: pages.apiInstructions,
    };
}
